import { Link } from "react-router-dom";
import AfricaNavbar from "@/components/AfricaNavbar";
import AfricaFooter from "@/components/AfricaFooter";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";

const INDUSTRIES = [
  { name: "Banking & Finance",           services: ["BusinessVerify™","SupplierVerify™","IdentityVerify™","TransactionVerify™","THOM Escrow™"], typicalUseCase: "Collateral · KYB · encumbrance · settlement · dispute evidence" },
  { name: "Insurance",                    services: ["AutoVerify™","PropertyVerify™","EquipmentVerify™","DocumentVerify™"], typicalUseCase: "Pre-underwriting inspections · claim evidence · fraud triangulation" },
  { name: "Government & Regulators",      services: ["Executive Intelligence","Evidence Vault","Audit Trails","Enterprise APIs"], typicalUseCase: "Statutory verification support · immutable evidence · dashboards" },
  { name: "Automotive & Dealerships",     services: ["AutoVerify™","Vehicle Marketplace","Buyer Protection","Trust Network"], typicalUseCase: "Verified listings · buyer unlocks · dealer subscriptions" },
  { name: "Real Estate",                  services: ["PropertyVerify™","THOM Escrow™","DocumentVerify™","Digital Passport"], typicalUseCase: "Title · encumbrance · deed verification · valuation-support" },
  { name: "Mining & Industrial",          services: ["MiningAssetVerify™","EquipmentVerify™","MachineryVerify™"], typicalUseCase: "Provenance · high-value asset passports · transfer verification" },
  { name: "Energy",                       services: ["EnergyAssetVerify™","BusinessVerify™"], typicalUseCase: "Grid & solar asset verification · IPP counterparty checks" },
  { name: "Agriculture",                  services: ["AgricultureVerify™","EquipmentVerify™","SupplierVerify™"], typicalUseCase: "Farm & equipment verification · offtake counterparty checks" },
  { name: "Logistics, Trade & Customs",   services: ["CustomsVerify™","TradeVerify™","DocumentVerify™"], typicalUseCase: "Cross-border · bill-of-entry reconciliation · consignment tracking" },
  { name: "Corporate Procurement",        services: ["SupplierVerify™","ContractorVerify™","TransactionVerify™"], typicalUseCase: "Tier-N supplier vetting · payment-conditional verification" },
  { name: "Luxury Assets",                services: ["LuxuryAssetVerify™","IdentityVerify™"], typicalUseCase: "Provenance · chain-of-custody · identity assurance" },
  { name: "Fleet Operators",              services: ["AutoVerify™","Digital Passport","Portfolio Dashboards"], typicalUseCase: "Portfolio inspections · continuity of ownership · resale readiness" },
];

export default function AfricaIndustries() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <AfricaNavbar />
      <section className="max-w-[1500px] mx-auto px-6 py-16 lg:py-24">
        <div className="max-w-[820px]">
          <div className="kicker text-white/60">Industries served</div>
          <h1 className="display text-4xl lg:text-6xl mt-3 leading-[1.02]">Independent verification for every high-value industry.</h1>
          <p className="mt-5 text-white/70 text-[15px] leading-[1.75]">
            THOM Verify™ delivers institution-grade evidence to twelve industry verticals across
            Africa. Each vertical draws on the same verification engine, Trust Network and evidence
            vault — configured for the regulatory rules that apply in that industry and country.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-3">
          {INDUSTRIES.map((ind, i) => (
            <div key={ind.name} className="border border-white/10 bg-white/[0.02] p-6" data-testid={`africa-industry-${i}`}>
              <h3 className="text-[18px] font-semibold">{ind.name}</h3>
              <p className="text-[12.5px] text-white/60 mt-1">{ind.typicalUseCase}</p>
              <div className="mt-4 flex flex-wrap gap-1.5">
                {ind.services.map((s) => (
                  <span key={s} className="mono text-[10px] uppercase tracking-widest px-2 py-1 border border-white/15 text-white/80 rounded-sm">{s}</span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 border border-white/10 bg-white/[0.02] p-6 lg:p-8 flex flex-col lg:flex-row items-start lg:items-center gap-6">
          <div className="flex-1">
            <h3 className="text-2xl font-semibold">Your industry isn't listed?</h3>
            <p className="text-[13.5px] text-white/70 mt-2">Reach out — every service is available under enterprise engagement.</p>
          </div>
          <Link to="/africa/enterprise#request"><Button size="lg" className="bg-[#B08C4A] hover:bg-[#8f6f34] text-black">Request Enterprise Verification <ChevronRight className="ml-1.5 h-4 w-4" /></Button></Link>
        </div>
      </section>
      <AfricaFooter />
    </div>
  );
}
